import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Archive, Download } from "lucide-react";
import { toast } from "sonner";

export const ResetBackups = ({ refreshKey }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.get("/admin/reset/backups").then((r) => setItems(r.data)).catch(() => {});
  }, [refreshKey]);

  const download = async (b) => {
    setBusy(b.id);
    try {
      const r = await api.get(`/admin/reset/backups/${b.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `trueline-backup-${b.created_at.slice(0, 10)}-${b.id.slice(0, 8)}.json`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Falha ao baixar backup");
    } finally { setBusy(null); }
  };

  return (
    <div className="rounded-xl border border-slate-800 bg-[#0B1120] p-5" data-testid="reset-backups">
      <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-500 mb-1 flex items-center gap-1.5">
        <Archive className="w-3 h-3" />Backups · {items.length}
      </div>
      <div className="text-xs text-slate-500 mb-3">Uma cópia de segurança é salva automaticamente antes de cada limpeza.</div>
      {items.length === 0 ? (
        <div className="text-center text-slate-500 py-6 text-sm" data-testid="reset-backups-empty">Nenhum backup ainda</div>
      ) : (
        <div className="divide-y divide-slate-800/60">
          {items.map((b) => (
            <div key={b.id} data-testid={`backup-${b.id}`} className="py-2.5 flex items-center gap-3">
              <div className="flex-1 min-w-0">
                <div className="text-xs text-slate-300 truncate"><strong className="font-mono text-emerald-300">{b.total}</strong> registros · {b.reason}</div>
                <div className="text-[10px] font-mono text-slate-500 mt-0.5">{new Date(b.created_at).toLocaleString()} · {b.actor}</div>
              </div>
              <Button size="sm" variant="outline" onClick={() => download(b)} disabled={busy === b.id || !b.total}
                data-testid={`backup-download-${b.id}`} className="border-slate-700 bg-slate-900/40 text-xs h-7">
                <Download className="w-3 h-3 mr-1.5" />{busy === b.id ? "Baixando..." : "Baixar"}
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
